import { Wrapper } from 'shared/ui/Wrapper/Wrapper';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { useEffect, useState } from 'react';
import { useApi } from 'app/api/APIProvider';
import { TransactionCards } from 'entities/TransactionCards';
import { TransactionCardsTheme } from 'entities/TransactionCards/TransactionCards';
import { APITransactionInfo } from 'app/api/APITypes';
import { PolicyCard } from 'entities/PolicyCard';
import { PolicyCardTheme } from 'entities/PolicyCard/PolicyCard';
import { PageLoader } from 'shared/ui/PageLoader/PageLoader';
import { ConditionCard } from 'entities/ConditionCard/ConditionCard';
import { AppLink } from 'shared/ui/AppLink/AppLink';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import plug from 'shared/assets/img/pages/card-plug.png';
import PlayIcon from 'shared/assets/icons/playIcon.svg';
import Logo from 'shared/assets/img/sber_logo.png';
import cls from './InvestmentsPage.module.scss';

export const InvestmentsPage = () => {
    const api = useApi();
    const [userInvest, setUserInvest] = useState<APITransactionInfo>({ sum: 0, history: [] });
    const [hasOpenedProducts, setHasOpenedProducts] = useState<boolean>(false);
    const [financeInfo, setFinanceInfo] = useState<any>({
        dms: {status: false},
        dsj: {status: false},
        investment: {
            depositAmount: 11,
            refillPerYear: 11,
            totalSum: 11,
            status: true,
        },
        nsj: {accumulated: '30000', contributionSum: 30000, status: true},
        osago: {status: false},
        property_insurance: {status: false},
        sjz: {status: true},
        ipp: {
            depositAmount: 11,
            refillPerYear: 11,
            totalSum: 11,
            status: true,
        },
    })
    const [isLoaded, setIsLoaded] = useState<boolean>(false);

    const banner = {
        name: "Пока у вас нет инвестиционных продуктов",
        description: "Вы можете зайти в раздел мои финансы и приобрести их",
        img: plug,
        button: {
            text: 'Мои финансы',
            url: '/finance'
        },
        cost: "",
        type: "banner",
    }

    const conditions = [
        {
            name: 'Брокерский счет',
            depositAmount: financeInfo.investment.depositAmount,
            refillPerYear: financeInfo.investment.refillPerYear,
            percentageRate: '14%',
            term: '4 года',
            totalSum: financeInfo.investment.totalSum,
            status: financeInfo.investment.status,
            button: {
                url: '/finance/policy/investment',
            },
        },
        {
            name: 'Индивидуальный пенсионный вклад',
            depositAmount: financeInfo.ipp.depositAmount,
            refillPerYear: financeInfo.ipp.refillPerYear,
            percentageRate: '10%',
            term: '10 лет',
            totalSum: financeInfo.ipp.totalSum,
            status: financeInfo.ipp.status,
        }
    ];

    const getUserMoney = async () => {
        const { investment } = await api.GetUserMoney('moneybox');
        const financeInfo = await api.GetFinanceInfo();
        setHasOpenedProducts(!![financeInfo.ipp, financeInfo.investment].filter((value) => value.status).length);
        // setClosedDeposits(deposits.filter((deposit: IDeposit) => !deposit.status));
        setFinanceInfo(financeInfo);
        setUserInvest(investment);
        setIsLoaded(true);
    };

    useEffect(() => {
        getUserMoney();
    }, [])

    if (!isLoaded) return <PageLoader />
    return (
        <div className={cls.page}>
            <Wrapper className={cls.mainWrapper}>
                <main className={cls.main}>
                    {
                        userInvest.length === 0 && !hasOpenedProducts ? (
                            <>
                                <Text className={cls.title} color="#353850" size={TextSize.text_36}>Мои инвестиции</Text>
                                <PolicyCard banner={banner} theme={PolicyCardTheme.banner} />
                            </>
                        ) : (
                            <>
                                <div>
                                    <Text className={cls.title} color="#353850" size={TextSize.text_36}>Мои инвестиции</Text>
                                    <div className={cls.conditionsWrapper}>
                                        {
                                            conditions.map((condition) => {
                                                if (condition.status === false) return;
                                                return <ConditionCard conditions={condition}/>
                                            })
                                        }
                                    </div>
                                </div>
                                <div>
                                    <Text className={cls.title} color="#353850" size={TextSize.text_36}>История</Text>
                                    <div className={cls.cardsWrapper}>
                                        {
                                            userInvest.map((transaction: { name: string, value: number }, index: number) => {
                                                return <TransactionCards transaction={transaction} theme={TransactionCardsTheme.closed} key={index} />
                                            })
                                        }
                                    </div>
                                </div>
                            </>
                        )
                    }
                </main>
                <AppLink to="/plot" className={cls.backToGameButton}>
                    <Button
                        theme={ButtonTheme.BACK_TO_GAME}
                        icon={<PlayIcon/>}
                        >
                        Продолжить сюжет
                    </Button>
                </AppLink>
                <img className={cls.logo} src={Logo} alt="" />
            </Wrapper>
        </div>
    );
};
